import MembershipCancellation from '../../components/membership_cancellations/membership_cancellation';

angular.module('gym').value('MembershipCancellation', MembershipCancellation);
